/* eslint-disable linebreak-style */
/* eslint-disable quotes */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { styled } from '@mui/material/styles';
import { PickersToolbar, pickersToolbarClasses } from '@mui/x-date-pickers/internals';
import { formatFullDate, formatYear, getDateLocale } from '../../utils/date';

const StyledToolbar = styled(PickersToolbar)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2.5),
    width: "100%",
    borderRadius: "4px",
    [`& .${pickersToolbarClasses.content}`]: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
}));

export function CustomToolbar(props) {
    const { value } = props;
    const date = value ? new Date(value) : new Date();
    const locale = getDateLocale();
    return (
        <StyledToolbar>
            <div style={{ opacity: 0.7, fontSize: 14 }}>
                {date ? formatYear(date, locale) : ""}
            </div>
            <div style={{ fontSize: 30, fontWeight: "400" }}>
                {date ? formatFullDate(date, locale) : ""}
            </div>
        </StyledToolbar>
    );
}
export default CustomToolbar;
